/**
 * «چرا این پیش‌نویس رد می‌شود؟» — تایپ کردن و انتخاب از دلایلِ قبلی، با هم.
 *
 * ═══ چرا `window.prompt` نبود ═══
 *
 * نسخه‌ی اول `prompt()` بود و دو ایراد داشت که هر دو در عمل خوردند:
 * مرورگر می‌تواند خاموشش کند (و آن وقت دکمه بی‌صدا هیچ‌کاری نمی‌کند)، و
 * فهرستِ دلایلِ قبلی در آن جا نمی‌شود. دلیلی که هر بار از نو تایپ شود،
 * هر بار کمی فرق می‌کند — و شش ماه بعد «چرا این‌ها رد شدند؟» جوابِ
 * شمردنی ندارد.
 *
 * ═══ چرا `datalist` و نه یک `select` ═══
 *
 * فهرست **بسته نیست**. `select` یعنی فقط از این‌ها انتخاب کن، که غلط
 * است: دلیلِ تازه همیشه ممکن است و همان هم باید به فهرستِ دفعه‌ی بعد
 * اضافه شود. `input list=…` هر دو را با یک کنترل می‌دهد — تایپ کن، یا
 * از فهرستِ بازشو بردار.
 *
 * ⚠️ **دلایلِ قبلی از ردیف‌هایی که همین حالا در جدول‌اند خوانده می‌شوند،
 * نه از یک کوئریِ تازه.** هزینه‌اش صفر است و همان چیزی را می‌دهد که لازم
 * است: چیزهایی که خودت قبلاً نوشته‌ای.
 */
import React, { useState } from 'react';
import { MANUAL_REJECT_PREFIX, rejectSuggestions } from '@/core/lib/sourcePipeline';
import { Modal } from '@/ui/Modal';

export function RejectDialog({ label, seen, busy, onClose, onPick }: {
  /** نامِ منبع، تا معلوم باشد کدام ردیف رد می‌شود. */
  label: string;
  /** `promote_outcome`ِ همه‌ی ردیف‌های جدول — منبعِ دلایلِ قبلی. */
  seen: (string | null | undefined)[];
  busy: boolean;
  onClose: () => void;
  /** متنِ نهایی، **با** پیشوندِ «دستی: ». */
  onPick: (reason: string) => void;
}) {
  const options = rejectSuggestions(seen);
  const [reason, setReason] = useState('');
  const text = reason.trim();

  return (
    <Modal title={`ردِ ${label}`}
      hint="همان لحظه ثبت می‌شود. دلیل زیرِ ردیف نوشته می‌شود و بعداً قابلِ برگرداندن است."
      onClose={onClose}>
      <input className="input" list="reject-reasons" value={reason} autoFocus
        placeholder="دلیل — تایپ کن یا از فهرست بردار"
        onChange={(e) => setReason(e.target.value)}
        onKeyDown={(e) => { if (e.key === 'Enter' && text) onPick(MANUAL_REJECT_PREFIX + text); }} />
      <datalist id="reject-reasons">
        {options.map((o) => <option key={o} value={o} />)}
      </datalist>

      {/*
        چیپ‌ها تکرارِ همان فهرست‌اند و عمداً: منوی `datalist` تا وقتی کسی
        در کادر تایپ نکند باز نمی‌شود، و کسی که برای بارِ اول این پنجره را
        می‌بیند نمی‌داند فهرستی هم هست.
      */}
      <div className="chiprow" style={{ marginBottom: 8 }}>
        {options.slice(0, 8).map((o) => (
          <button key={o} type="button"
            className={o === text ? 'chip on' : 'chip'}
            onClick={() => setReason(o)}>{o}</button>
        ))}
      </div>

      <p className="dim" style={{ fontSize: 12 }}>
        در جدول این‌طور ذخیره می‌شود:{' '}
        <span className="mono">{MANUAL_REJECT_PREFIX}{text || '…'}</span>
        {' — '}پیشوند برای این است که حکمِ تو از حکمِ خودکارِ کرالر جدا بماند.
      </p>

      <button className="btn block" type="button" disabled={!text || busy}
        onClick={() => onPick(MANUAL_REJECT_PREFIX + text)}>
        {busy ? '…' : 'ردش کن'}
      </button>
    </Modal>
  );
}
